export const compareUnits = (unit1, unit2) => {
    if (unit1.unit_type !== unit2.unit_type) {
        return unit1.unit_type > unit2.unit_type ? -1 : 1;
    }
    if (unit1.unit_number !== unit2.unit_number) {
        return unit1.unit_number < unit2.unit_number ? -1 : 1;
    }
    return 0;
};
